import { Component } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-contact-header',
  templateUrl: './contact-header.component.html',
  styleUrl: './contact-header.component.scss',
  imports: [TranslatePipe],
})
export class ContactHeaderComponent {}
